import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Orders = () => {
    // Fetch JWT from localStorage
    const getAuthToken = () => localStorage.getItem("token");

    const navigate = useNavigate();

    // Axios instance with Authorization header
    const axiosInstance = axios.create({
        baseURL: "/api",
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = getAuthToken();
        if (!token) {
            navigate("/login");
            return;
        }
        const fetchOrders = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axiosInstance.get("/admin/orders");
                setOrders(res.data);
            } catch (err) {
                navigate("/login");
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, []);

    const handleDelete = async (orderId) => {
        if (!window.confirm("Bestellung wirklich löschen?")) return;
        try {
            await axiosInstance.delete(`/admin/orders/${orderId}`);
            setOrders((prev) => prev.filter((o) => o._id !== orderId));
        } catch (err) {
            alert("Fehler beim Löschen der Bestellung.");
        }
    };

    return (
        <div className="max-w-2xl mx-auto bg-white p-6 rounded-md shadow-md mt-16">
            <h1 className="text-2xl font-bold mb-4">Bestellungen</h1>
            {loading && <div>Lädt...</div>}
            {error && <div className="text-red-500">{error}</div>}
            {!loading && orders.length === 0 && (
                <div>Keine Bestellungen gefunden.</div>
            )}
            <ul className="space-y-4">
                {orders.map((order) => (
                    <li
                        key={order._id}
                        className="border rounded p-4 flex flex-col md:flex-row md:items-center md:justify-between"
                    >
                        <div>
                            <div className="font-semibold">
                                Bestellnummer: {order.orderNumber}
                            </div>
                            <div>
                                Kunde: {order.formData?.firstName || "-"}{" "}
                                {order.formData?.lastName || "-"}
                            </div>
                            <div>
                                Gesamtpreis: {order.totalPrice?.toFixed(2)} €
                            </div>
                            <div>
                                Status:{" "}
                                {order.accepted
                                    ? "Bestätigt"
                                    : order.denied
                                    ? "Abgelehnt"
                                    : "Offen"}
                            </div>
                            <div className="text-md text-gray-500">
                                {new Date(order.createdAt).toLocaleString()}
                            </div>
                        </div>
                        <button
                            className="mt-2 md:mt-0 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                            onClick={() => handleDelete(order._id)}
                        >
                            Löschen
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Orders;
